"use client";

import Link from "next/link";
import { AgentReadyUrlForm } from "~/components/siteglue/agent-ready/scan-form";
import { FadeIn, HomeEyebrow, HomeHeading, HomeLead, HomeSection } from "~/components/siteglue/home/section-shell";
import { HeroNeuralNetwork } from "~/components/siteglue/landing/hero-neural-network";
import { HOMEPAGE_URL_PLACEHOLDER } from "~/lib/siteglue/landing-redesign/copy";
import {
  HIRE_TRISH_CTA_LABEL,
  HIRE_TRISH_SCAN_REPORTS,
  MEET_TEAM_SITEGLUE_CTA,
  TEAM_SITEGLUE_HREF,
} from "~/lib/siteglue/team-siteglue/roster";

export function HireTrishPage({ initialUrl }: { initialUrl?: string }) {
  return (
    <div className="min-h-screen bg-white text-slate-900" data-testid="hire-trish-page">
      <section className="relative isolate overflow-hidden bg-white">
        <HeroNeuralNetwork />
        <div className="relative z-10 mx-auto max-w-3xl px-4 py-16 sm:px-6 sm:py-24">
          <HomeEyebrow>Hire Trish</HomeEyebrow>
          <h1 className="mt-4 text-balance text-4xl font-semibold tracking-tight text-slate-900 sm:text-5xl">
            Free Marketing Analysis
          </h1>
          <p className="mt-4 max-w-2xl text-lg leading-relaxed text-slate-600">
            Enter your website. Trish coordinates the existing agent-readiness, AI-answer, and
            conversion checks. No account and no payment. A single combined marketing report with
            specialist recommendations is not live yet.
          </p>
          <div className="mt-8 max-w-xl rounded-md border border-slate-200 bg-white p-5">
            <AgentReadyUrlForm
              className="mx-0 mt-0 max-w-none"
              urlPlaceholder={HOMEPAGE_URL_PLACEHOLDER}
              initialUrl={initialUrl}
              stepZeroCta={HIRE_TRISH_CTA_LABEL}
              hideSteps
              urlOnly
              fixedReports={[...HIRE_TRISH_SCAN_REPORTS]}
            />
          </div>
          <p className="mt-4 text-sm text-slate-500">
            You will get the current ARO, AEO, and CRO results. Trish will use those findings in a
            later phase to recommend specialists.
          </p>
          <Link
            href={TEAM_SITEGLUE_HREF}
            className="mt-6 inline-flex h-11 items-center justify-center rounded-full border border-slate-300 px-5 text-sm font-semibold text-slate-800 hover:bg-slate-50"
          >
            {MEET_TEAM_SITEGLUE_CTA}
          </Link>
        </div>
      </section>
      <HomeSection tone="slate">
        <FadeIn className="max-w-3xl">
          <HomeHeading>What happens after you submit a URL</HomeHeading>
          <HomeLead>
            SiteGlue runs the same public scanner used on the ARO, AEO, and CRO audit pages. Copy
            never claims ChatGPT already recommends you, guaranteed rankings, or that this replaces
            your agency.
          </HomeLead>
        </FadeIn>
      </HomeSection>
    </div>
  );
}
